import { useTranslation } from 'react-i18next';
import { Col, Descriptions, Row as AntdRow } from 'antd';

import { BenefitGroup } from 'all-in-one-shared-api';
import {
  getGroupAmountDescriptionLabel,
  getGroupIdLabel,
  getGroupLimitDescriptionLabel,
} from 'pages/benefits/utils/utils';
import styled from 'styled-components';

const Row = styled(AntdRow)`
  margin-top: 1rem;
`;

interface BenefitGroupSectionProps {
  benefitGroups?: Array<BenefitGroup>;
}

const BenefitGroupSection = ({ benefitGroups }: BenefitGroupSectionProps): JSX.Element => {
  const { i18n } = useTranslation();

  if (!benefitGroups || benefitGroups.length == 0) return <></>;

  return (
    <Row gutter={[8, 8]}>
      {benefitGroups.map((benefitGroup: BenefitGroup) => {
        const groupIdLabel = getGroupIdLabel(i18n.language, benefitGroup);
        const title = `${groupIdLabel} (${benefitGroup.benefitGroupLabel})`;
        const limitDescriptionLabel = getGroupLimitDescriptionLabel(i18n.language, benefitGroup);
        const amountLabel = getGroupAmountDescriptionLabel(i18n.language, benefitGroup);
        const amountValue = benefitGroup.maxAmount ? `HKD ${Number(benefitGroup.maxAmount).toLocaleString()}` : '';

        return (
          <Col key={benefitGroup.benefitGroupId} xs={24} md={12}>
            <Descriptions title={title} bordered column={1} size="small">
              {limitDescriptionLabel && benefitGroup.limit && (
                <Descriptions.Item label={limitDescriptionLabel} labelStyle={{ width: '50%' }}>
                  {benefitGroup.limit}
                </Descriptions.Item>
              )}

              {amountLabel && amountValue && (
                <Descriptions.Item label={amountLabel} labelStyle={{ width: '50%' }}>
                  {amountValue}
                </Descriptions.Item>
              )}
            </Descriptions>
          </Col>
        );
      })}
    </Row>
  );
};

export default BenefitGroupSection;
